module.exports = __webpack_public_path__ + "img/11.771315f7.jpg";